import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IntegrationFormTypes } from "models/formTypes";
import { StripeConnectFormProps } from "models/propTypes/integrationsPropTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const StripeConnectDescription: React.FC = () => (
  <Grid container className={cssExports.formControlDescription}>
    {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Integrations.UseStripeConnectDescription)}
  </Grid>
);

const StripeConnectUnavailableDescription: React.FC = () => (
  <Grid container className={cssExports.formControlDescription}>
    {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Integrations.StripeStatusUnavailableDescription)}
  </Grid>
);

const StripeConnectForm: ForwardRefRenderFunction<FormHandles, StripeConnectFormProps> = (props, ref) => {
  return (
    <GenericForm<IntegrationFormTypes.StripeConnect>
      formRef={ref}
      {...props}
      disableSubmitOn={(values) => props.statusUnavailable === true || (!values.useStripeConnect && !props.isActive)}
      fields={{
        useStripeConnect: {
          label: TranslationKeys.Integrations.UseStripeConnect,
          type: FormEnums.FormFieldType.TOGGLE,
          disabled: props.statusUnavailable === true,
          classes: { formControl: cssExports.inlineLabel },
        },
        useStripeConnectDescription: {
          label: "",
          type: FormEnums.FormFieldType.CUSTOM,
          customField:
            props.statusUnavailable === true ? <StripeConnectUnavailableDescription /> : <StripeConnectDescription />,
        },
      }}
    />
  );
};

export default forwardRef(StripeConnectForm);
